<template>
  <a
    v-translate
    :href="appLoginUrl"
    :class="$style.container"
  >login</a>
</template>

<script>
  import buildURL from 'axios/lib/helpers/buildURL'

  export default {
    props: {
      loginUrl: {
        type: String
      },
      profileId: {
        type: String
      },
      loginState: {
        type: String
      },
      loginRedirectUrl: {
        type: String
      }
    },
    locales: {
      'en': {
        'login': 'Sign in'
      },
      'ru': {
        'login': 'Войти'
      }
    },
    computed: {
      appLoginUrl () {
        return buildURL(this.loginUrl)
      }
    }
  }
</script>

<style lang="scss" module>
  @import "~@stylesheets/includes/mixins";
  @import "~@stylesheets/common/links/link-a";

  /**
   * DESKTOP
   */
  @include desktop {
    /**
     * Container
     */
    .container {
      display: flex;
      align-items: center;
      padding: 0px 30px;
      @include link-a1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginButton.vue